import {Component} from 'react'
import PropTypes from 'prop-types'
import {connect as messengerConnect} from '../../../account/app/actions/messenger'
import {connect} from 'react-redux'
import {haveUnreadMessages, haveNewMessage, unreadMessageCount} from '../../actions/app'
import store from 'store'
import {bindActionCreators} from 'redux'
import {getMessengerClient} from '../../../../react/account/app/utils/messenger'
import getUnreadMessagesCount from '../../../core/utils/sendbirdUnreadMessageCount'

class UnreadMessenger extends Component {
  static defaultProps = {
    user: {},
    sendbirdAppId: null
  }

  static propTypes = {
    authenticated: PropTypes.bool,
    haveNewMessage: PropTypes.func,
    haveUnreadMessages: PropTypes.func.isRequired,
    isLogged: PropTypes.bool,
    isSuperUser: PropTypes.bool,
    messengerConnect: PropTypes.func.isRequired,
    sendbirdAppId: PropTypes.string.isRequired,
    sendbirdUser: PropTypes.object,
    unreadMessageCount: PropTypes.func.isRequired,
    user: PropTypes.object
  }

  constructor (props) {
    super(props)

    this.state = {
      sb: null
    }
  }

  componentDidMount () {
    if (this.props.isLogged) {
      this.props.messengerConnect(this.props.sendbirdAppId, this.props.sendbirdUser)
      store.set('isSuperUser', this.props.isSuperUser)
      this.unreadMessageCount()
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (!prevProps.authenticated && this.props.authenticated) {
      this.sendbirdConnect()
    }
  }

  unreadMessageCount () {
    let count = getUnreadMessagesCount()
    count.then(unreadCount => {
      this.props.unreadMessageCount(unreadCount)
    })
  }

  sendbirdConnect () {
    const sb = getMessengerClient()

    let channelHandler = new sb.ChannelHandler()

    channelHandler.onChannelChanged = channel => {
      let conversationUnreadMessages = store.get('conversation_unread_messages')
      if (!conversationUnreadMessages) {
        conversationUnreadMessages = {}
      }

      conversationUnreadMessages[channel.url] = channel.unreadMessageCount

      let countUnreadMessages = 0
      for (let index in conversationUnreadMessages) {
        countUnreadMessages += conversationUnreadMessages[index]
      }
      if (this.props.user.messenger_id !== channel.lastMessage.sender.userId) {
        let lastMessageObject = {
          sender: channel.lastMessage.sender.nickname,
          channelUrl: channel.lastMessage.channelUrl,
          messageId: channel.lastMessage.messageId,
          message: channel.lastMessage.message ? channel.lastMessage.message.replace(/<[^>]+>/g, '') : 'file_message'
        }
        this.props.haveNewMessage(lastMessageObject)
      }
      store.set('conversation_unread_messages', conversationUnreadMessages)
      this.props.haveUnreadMessages(countUnreadMessages > 0)
    }
    sb.addChannelHandler('GLOBAL_CHANNEL_EVENTS', channelHandler)

    sb.getTotalUnreadChannelCount((count, error) => {
      if (error) console.error(error)
      this.props.haveUnreadMessages(count > 0)
    })
  }

  render () {
    return null
  }
}

const mapStateToProps = state => ({
  isLogged: state.app.isLogged,
  user: state.app.user,
  sendbirdUser: state.app.sendBird.user,
  sendbirdAppId: state.app.sendBird.app_id,
  authenticated: state.messenger.auth.status.authenticated,
  isSuperUser: state.app.isSuperUser
})

const mapDispatchToProps = dispatch => bindActionCreators({haveUnreadMessages, haveNewMessage, messengerConnect, unreadMessageCount}, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnreadMessenger)
